import React, { useMemo, memo } from "react";
import { motion } from "framer-motion";

const BotMessage = memo(({ message }) => {
  // Enhanced parser for bold text and multi-line breaks - MEMOIZED
  const parsedContent = useMemo(() => {
    if (!message) return null;
    
    // Split by lines first
    return message.split("\n").map((line, lineIdx) => {
      if (!line.trim() && lineIdx !== 0) return <br key={`br-${lineIdx}`} />;
      
      // Parse bolding in each line
      const parts = line.split(/(\*\*.*?\*\*)/g);
      const renderedLine = parts.map((part, i) => {
        if (part.startsWith("**") && part.endsWith("**")) {
          return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        return part;
      });

      return (
        <div key={lineIdx} className="message-line">
          {renderedLine}
        </div>
      );
    });
  }, [message]);

  return (
    <motion.div 
      initial={{ opacity: 0, x: -10, y: 5 }}
      animate={{ opacity: 1, x: 0, y: 0 }}
      className="bot-msg-wrapper"
    >
      <div className="bot-bubble">
        {parsedContent}
      </div>
      <style>{`
        .bot-msg-wrapper {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 16px;
        }
        .bot-bubble {
          background: rgba(255, 255, 255, 0.95);
          color: #1e293b;
          padding: 10px 14px;
          border-radius: 2px 14px 14px 14px;
          max-width: 92%;
          font-size: 0.82rem;
          line-height: 1.6;
          box-shadow: 0 4px 15px rgba(0, 43, 90, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
          position: relative;
          white-space: pre-wrap !important;
          word-break: break-word;
        }
        
        .message-line {
          min-height: 1em;
          margin-bottom: 2px;
        }
        
        /* Handle markdown-like formatting if present */
        .bot-bubble strong { color: #004080; font-weight: 700; }
      `}</style>
    </motion.div>
  );
});

export default BotMessage;
